var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxAppleNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_526)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_438_526",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_438_526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7689 20.59C21.4081 19.615 21.6464 19.1167 22.1339 18.0225C18.5373 16.6575 17.9631 11.5333 21.5164 9.57249C20.4331 8.20749 18.9056 7.41667 17.4648 7.41667C16.4248 7.41667 15.7098 7.68752 15.0706 7.93668C14.5289 8.14252 14.0414 8.32667 13.4348 8.32667C12.7848 8.32667 12.2106 8.12085 11.6039 7.90418C10.9431 7.66585 10.2497 7.41667 9.38304 7.41667C7.76888 7.41667 6.04639 8.40251 4.95222 10.0925C3.41389 12.4758 3.68472 16.9392 6.16555 20.7525C7.05389 22.1175 8.24555 23.645 9.79472 23.6667C10.4447 23.6775 10.8672 23.4825 11.3331 23.2767C11.8639 23.0383 12.4381 22.7783 13.4456 22.7783C14.4531 22.7675 15.0164 23.0383 15.5473 23.2767C16.0023 23.4825 16.4139 23.6775 17.0531 23.6667C18.6239 23.645 19.8806 21.955 20.7689 20.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2366 2C17.41 3.19167 16.9225 4.37251 16.2833 5.19584C15.6008 6.08418 14.4091 6.7775 13.2608 6.73417C13.055 5.58583 13.5858 4.40499 14.2358 3.61416C14.9616 2.74749 16.1858 2.07583 17.2366 2Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxAppleNew);
export default __webpack_public_path__ + "static/media/iconsax-apple-new.87251601c65ef71687ffad5b3d26d120.svg";
export { ForwardRef as ReactComponent };